import React, { useState, useEffect } from "react";
import logo from "../../static/ibtehaz_dark.png";
import themeLarge from "../ThemeLarge";

const MobileNavigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState("/");

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Origin Story", path: "/origin" },
    { name: "Projects", path: "/projects" },
    { name: "Blogs", path: "/blogs" },
    // { name: "Get In Touch", path: "/contact" },
  ];

  return (
    <>
      <style>{`
          .mobile-slide-menu {
          position: fixed;
          top: 56px;
          left: 0;
          height: calc(100% - 56px);
          width: 0;
          background-color: ${themeLarge.colors.secondary};
          overflow-x: hidden;
          transition: width 0.8s ease;
          z-index: 1040;
        }

        .mobile-slide-menu.open {
          width: 70%;
          transform: translateX(0);
        }

        .mobile-slide-menu .menu-content {
          padding: 1.5rem;
        }
        `}</style>
      {/* Mobile Nav (Bootstrap Visible Only on Small Screens) */}
      <nav
        className="d-flex d-lg-none justify-between align-items-center px-3 py-2 border-bottom position-sticky top-0"
        style={{ zIndex: 1050, backgroundColor: themeLarge.colors.secondary }}
      >
        {/* Hamburger */}
        <button
          onClick={toggleMenu}
          className="btn"
          style={{
            fontSize: themeLarge.fontSize.h2,
            color: themeLarge.colors.primary,
          }}
        >
          ☰
        </button>

        {/* Logo */}
        <div className="ms-auto">
          <span
            className="text-capitalize"
            style={{
              marginRight: "10px",
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.h2,
              color: themeLarge.colors.primary,
            }}
          >
            {navLinks.find((link) => link.path === currentPath)?.name || ""}
          </span>
        </div>
      </nav>

      {/* Slide-in Menu */}
      <div
        className={`mobile-slide-menu ${menuOpen ? "open" : ""}`}
        onClick={closeMenu}
      >
        <div className="menu-content" onClick={(e) => e.stopPropagation()}>
          {navLinks.map((link) => (
            <a
              key={link.path}
              href={link.path}
              onClick={closeMenu}
              className={`d-block py-2 border-bottom ${
                currentPath === link.path ? "text-danger" : "text-dark"
              }`}
              style={{
                fontSize: themeLarge.fontSize.h3,
                textDecoration: "none",
                fontFamily: "Kumbh Sans",
              }}
            >
              {link.name}
            </a>
          ))}

          <img src={logo} height="200px" alt="Ibtehaz Logo" />
          <div
            className="text-center text-muted"
            style={{
              fontSize: themeLarge.fontSize.small,
            }}
          >
            © Ibtehaz 2025
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNavigation;
